import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import MarketingNavbar from './components/MarketingNavbar';
import MarketingFooter from './components/MarketingFooter';
import MarketingHome from './pages/MarketingHome';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import QuoteRequestPage from './pages/QuoteRequestPage';
import ContactPage from './pages/ContactPage';
import CitiesListPage from './pages/CitiesListPage';
import CityDetailPage from './pages/CityDetailPage';
import AdminLogin from './pages/AdminLogin';
import AdminContentManagement from './pages/AdminContentManagement';
import './App.css';

function App() {
  useEffect(() => {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (siteKey && !document.querySelector('script[src*="recaptcha"]')) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-gray-50">
          <Routes>
            {/* Marketing Website Routes */}
            <Route path="/" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <MarketingHome />
                </div>
                <MarketingFooter />
              </div>
            } />
            
            <Route path="/services" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <ServicesPage />
                </div>
                <MarketingFooter />
              </div>
            } />
            
            <Route path="/about" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <AboutPage />
                </div>
                <MarketingFooter />
              </div>
            } />
            
            <Route path="/quote" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <QuoteRequestPage />
                </div>
                <MarketingFooter />
              </div>
            } />
            
            <Route path="/contact" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <ContactPage />
                </div>
                <MarketingFooter />
              </div>
            } />

            <Route path="/cities" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <CitiesListPage />
                </div>
                <MarketingFooter />
              </div>
            } />

            <Route path="/cities/:slug" element={
              <div className="flex flex-col min-h-screen">
                <MarketingNavbar />
                <div className="flex-grow">
                  <CityDetailPage />
                </div>
                <MarketingFooter />
              </div>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/content" element={<AdminContentManagement />} />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;